import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EstatusLegalesResponse, IGetAllEstatusLegales, IGetEstLeg6, IGetEstLegErr, IGetEstLegErrRes, IGetLstEstl } from '@p-p-portafolio/promociones/interfaces/estatus-legales';
import { environment } from 'src/environments/environment';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Ciclos } from '@p-p-portafolio/promociones/interfaces/ciclos';

@Injectable({
  providedIn: 'root'
})
export class EstatusLegalesService {
  private baseUrl = environment.apiNewBackBaseUrl + 'Promociones/';

  constructor(private http: HttpClient) {}

  form: UntypedFormGroup = new UntypedFormGroup({
    estatusLegal: new UntypedFormControl(null, [Validators.required]),
    diasDues: new UntypedFormControl(null),
    minimo: new UntypedFormControl(null),
    maximo: new UntypedFormControl(null),
    descripcion: new UntypedFormControl(null),
    provision: new UntypedFormControl(null),
    provisionInt: new UntypedFormControl(null),
    clasCartera: new UntypedFormControl(null),
    porcGarantia: new UntypedFormControl(null),
    origenReserva: new UntypedFormControl(null)
  });

  initializeFormGroup() {
    this.form.setValue({
      estatusLegal: '',
      diasDues: 0,
      minimo: 0,
      maximo: 0,
      descripcion: '',
      provision: 0,
      provisionInt: 0,
      clasCartera: 0,
      porcGarantia: 0,
      origenReserva: 0
    });
  }

  populateForm(entity: EstatusLegalesResponse) {
    this.form.setValue(entity);
  }

  getAll(payload: IGetAllEstatusLegales) {
    const url = `${this.baseUrl}GetEstLeg6`;
    return this.http.post<IGetEstLeg6>(url, payload);
  }

  GetLstEstl(usuario: string) {
    const url = `${this.baseUrl}GetLstEstl`;
    return this.http.post<IGetLstEstl>(url, {
      sUsuario: usuario
    });
  }

  GetLstEstlCC(usuario: string) {
    const url = `${this.baseUrl}GetLstEstlCC`;
    return this.http.post<IGetLstEstl>(url, {
      sUsuario: usuario
    });
  }

  GetLstEstlOR(usuario: string) {
    const url = `${this.baseUrl}GetLstEstlOR`;
    return this.http.post<IGetLstEstl>(url, {
      sUsuario: usuario
    });
  }

  // Mismo servicio para crear, editar y borrar, solo cambia el QUE
  // que = 1: crear, 2: editar, 3: borrar
  GetEstLegErr(payload: IGetEstLegErr) {
    const url = `${this.baseUrl}GetEstLegErr`;
    return this.http.post<IGetEstLegErrRes>(url, payload);
  }
}
